import React, { Component } from 'react';

class Mii extends Component {
    constructor(props) {
        super(props);
        this.clicked = this.clicked.bind(this);
        this.state = {hover:false};
    }

    clicked() {
        if (typeof this.props.selected === "function") {
            this.props.selected(this.props.i);
        }
    }

    render() {
        let width = this.props.width;

        return (
            <div className="highlight" onClick={this.clicked}
                 onMouseEnter={(e) => {this.setState({hover:true});}} onMouseLeave={(e) => {this.setState({hover:false});}}>
              <img className="mii-img" src={this.props.src} width={width} height={width} alt={this.props.i} />
              { false && this.state.hover &&
                  <img className="name-img" src={this.props.nameImg} alt={this.props.name}/>
              }
            </div>
        );
    }
}

export default Mii;
